import { TaskState } from '@schema';

// eslint-disable-next-line import/prefer-default-export
export const TASK_STATE_IS_IN_PROGRESS = [
  TaskState.CANCELLING,
  TaskState.RUNNING,
  TaskState.STARTING
];
